import {
  FetchLoyaltyAccountSuccessAction,
  FetchLoyaltyAccountFailureAction,
  FetchLoyaltyPointsSuccessAction,
  FetchLoyaltyPointsFailureAction,
  FetchLoyaltyRankSuccessAction,
  FetchLoyaltyRankFailureAction,
} from '../types/loyalty';

export const LoyaltyAccountEvents = {
  init: 'loyalty/FETCH_LOYALTY_CARD/init',
  request: 'loyalty/FETCH_LOYALTY_CARD/request',
  success: 'loyalty/FETCH_LOYALTY_CARD/success',
  failure: 'loyalty/FETCH_LOYALTY_CARD/failure',
  restoreAccount: 'loyalty/RESTORE_ACCOUNT_FROM_LOCAL_STORAGE',
} as const;

export const LoyaltyPointsEvents = {
  init: 'loyalty/FETCH_LOYALTY_POINTS/init',
  request: 'loyalty/FETCH_LOYALTY_POINTS/request',
  success: 'loyalty/FETCH_LOYALTY_POINTS/success',
  failure: 'loyalty/FETCH_LOYALTY_POINTS/failure',
} as const;

export const LoyaltyRankEvents = {
  init: 'loyalty/FETCH_LOYALTY_RANK/init',
  request: 'loyalty/FETCH_LOYALTY_RANK/request',
  success: 'loyalty/FETCH_LOYALTY_RANK/success',
  failure: 'loyalty/FETCH_LOYALTY_RANK/failure',
} as const;

export type ELoyaltyAccountEvents = {
  [LoyaltyAccountEvents.success]: FetchLoyaltyAccountSuccessAction;
  [LoyaltyAccountEvents.failure]: FetchLoyaltyAccountFailureAction;
  [LoyaltyAccountEvents.restoreAccount]: FetchLoyaltyAccountSuccessAction;
};

export type ELoyaltyPointsEvents = {
  [LoyaltyPointsEvents.success]: FetchLoyaltyPointsSuccessAction;
  [LoyaltyPointsEvents.failure]: FetchLoyaltyPointsFailureAction;
};

export type ELoyaltyRankEvents = {
  [LoyaltyRankEvents.success]: FetchLoyaltyRankSuccessAction;
  [LoyaltyRankEvents.failure]: FetchLoyaltyRankFailureAction;
};

export type ELoyaltyEvents = ELoyaltyAccountEvents & ELoyaltyPointsEvents & ELoyaltyRankEvents;
